import { t } from '@lingui/core/macro';
import { ApiErrorMessage, ApiErrorMessageProps } from 'noddi-ui-web';
import { useCurrentBrand } from '../../stores/BrandStore/brandStore';
import { getErrorCodesWithTrans } from '../../utils/getErrorCodesWithTranslations';

export const ApiErrorMessageWithTrans = ({ ...rest }: ApiErrorMessageProps) => {
  const { brandEmail } = useCurrentBrand();
  return (
    <ApiErrorMessage
      {...rest}
      errorCodes={getErrorCodesWithTrans(brandEmail)}
      translations={{ tryAgain: t`Try again` }}
    />
  );
};
